import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ClientDetailPageRoutingModule } from './client-detail-routing.module';

import { ClientDetailPage } from './client-detail.page';

import { ClientPickerModule } from '../../components/smr-client-picker/smr-client-picker.module';

import { TapRetryComponentModule } from '../../components/tap-retry/tap-retry.module';

import { ClientMergeModule } from '../../components/client-merge/client-merge.module';

import { ClientInfoModule } from '../../components/client-info/client-info.module';

import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';

import { ClientBookingsModule } from '../../components/client-bookings/client-bookings.module';
import { ClientSalesModule } from '../../components/client-sales/client-sales.module';
import { ClientCommunicationHistoryListComponentModule } from '../../components/client-communication-history-list/client-communication-history-list.module';
import { BookingPhotosManagerComponentModule } from '../../components/booking-photos-manager/booking-photos-manager.module';
import { SharedModule } from '../../shared.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ClientDetailPageRoutingModule,
    ClientPickerModule,
    TapRetryComponentModule,
    ClientMergeModule,
    ClientInfoModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    ClientBookingsModule,
    ClientSalesModule,
    ClientCommunicationHistoryListComponentModule,
    BookingPhotosManagerComponentModule,
    SharedModule
  ],
  declarations: [ClientDetailPage],
  exports:[ClientDetailPage]
})
export class ClientDetailPageModule {}
